module.exports = __webpack_public_path__ + "static/hero-qrcode.en-81ddbb00cd89b4ea8f7efdd573fbba15.svg";